//////////////////////////////////////
// FACILITY MAP

(() => {
  'use strict';

  document.addEventListener('DOMContentLoaded', () => {

    //////////////////////////////////////
    // DOM REFS

    const section   = document.querySelector('.facility-map');
    if (!section) return;

    const columns   = section.querySelector('.columns');
    const btnExpand = section.querySelector('.btn-expand-map');
    const btnClose  = section.querySelector('.map-close');

    //////////////////////////////////////
    // EVENTS

    btnExpand?.addEventListener('click', (e) => {
      e.preventDefault();
      columns.classList.add('expanded');
    });

    btnClose?.addEventListener('click', () => {
      columns.classList.remove('expanded');
    });

  });
})();
